import { Controller } from "@hotwired/stimulus";
import Chart from "chart.js/auto";

export default class extends Controller {
  static targets = ["canva"];

  static values = {
    data: Object,
    showLegend: Boolean,
  }

  connect() {
    var ctx = this.canvaTarget.getContext("2d");
    new Chart(ctx, {
      type:'line',
      data: this.dataValue,
      options: {
        interaction:{
          intersect: false
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
          }
        },
        scales: {
          y: {
            grid: {
              color: '#F5F5F5'
            },
            border: {
              display: false
            },
            beginAtZero: true,
            ticks: {
              callback: v => v / 1000 + "k",
            }
          },
          x: {
            border: {
              display: false
            },
            ticks: {
              callback: function(value ,index, values) {
                if (index === 0 || index === values.length - 1) {
                  return this.getLabelForValue(value);
                } else {
                  return null;
                }
              }
            },
            grid: {
              display: false
            },
          },
        },
        plugins: {
          legend: {
            display: this.showLegendValue || false,
            position: "bottom",
            labels: {
              usePointStyle: true,
              color: "black",
            },
          },
        }
      }
    })
  }
}
